/* eslint-disable jira/filename-case */
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { asyncValues } from '@jira/polaris__lib-ts-utils/src/async-value.tsx';
import { createErrorAnalytics } from '@jira/polaris__lib-errors/src/createErrorAnalytics.tsx';
import { updateProductSettingsFinancialYear } from './updateProductSettingsViewBlueprints.tsx';
import type { Props, State } from './ProductSettingsResponse.types.tsx';

export const updateDatesInitialMonth =
	(initialMonth: number): Action<State, Props, Promise<void>> =>
	async ({ setState, getState }) => {
		const state = getState();

		if (state.productSettings.status !== 'loaded') {
			return;
		}

		const previousInitialMonth = state.productSettings.value.dates.initialMonth;

		try {
			await updateProductSettingsFinancialYear(initialMonth);

			setState({
				productSettings: asyncValues.loaded({
					...state.productSettings.value,
					dates: {
						initialMonth,
					},
				}),
			});
		} catch (error) {
			if (error instanceof Error) {
				fireErrorAnalytics(createErrorAnalytics('polaris.error.fetchProductSettingsFailed', error));
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.error.controllers.product-settings.update-financial-year',
				'Failed to update financial year',
				error instanceof Error ? error : new Error(String(error)),
			);

			setState({
				productSettings: asyncValues.loaded({
					...state.productSettings.value,
					dates: {
						initialMonth: previousInitialMonth,
					},
				}),
			});

			throw error;
		}
	};
